import { NavigationContainer, DefaultTheme, DarkTheme } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import React, { useContext } from 'react';
import { ColorSchemeName } from 'react-native';

import NotFoundScreen from '../screens/NotFoundScreen';
import { RootStackParamList } from '../types';
import BottomTabNavigator from './BottomTabNavigator';
import IntroNavigator from './IntroNavigator';
import LinkingConfiguration from './LinkingConfiguration';
import { AuthContext } from '../contexts/auth/Store';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AboutScreen from '../screens/AboutScreen';

// If you are not familiar with React Navigation, we recommend going through the
// "Fundamentals" guide: https://reactnavigation.org/docs/getting-started
export default function Navigation({ colorScheme }: { colorScheme: ColorSchemeName }) {
  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      theme={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <RootNavigator />
    </NavigationContainer>
  );
}

// A root stack navigator is often used for displaying modals on top of all other content
// Read more here: https://reactnavigation.org/docs/modal
const Stack = createStackNavigator<RootStackParamList>();

function RootNavigator() {
  const auth: any = useContext(AuthContext);
  const [loading, setLoading] = React.useState(true);
  const [token, setToken] = React.useState(null);

  React.useEffect(() => {
    if (auth) {
      setToken(auth?.getUserData.userToken)
    } else {
      setToken(null)
    }
    return () => { }
  }, [auth])

  React.useEffect(() => {
    setLoading(true)

    const getToken = async () => {
      let _token = await AsyncStorage.getItem('userToken')
      if (_token) {
        setToken(_token)
      } else {
        setToken(false)
      }
      setLoading(false)
    }
    getToken()

    return () => { }
  }, [])

  return (
    !loading
      ? <Stack.Navigator
        screenOptions={{ headerShown: false }}
      >
        {
          token
            ? <Stack.Screen name="Root" component={BottomTabNavigator} />
            : <Stack.Screen name="Intro" component={IntroNavigator} />
        }
        <Stack.Screen name="NotFound" component={NotFoundScreen} options={{ title: 'Oops!' }} />
        <Stack.Screen name="About" component={AboutScreen} options={{ title: 'About Suplias Now' }} />
      </Stack.Navigator>
      : null
  );
}
